import axios from 'axios';

// Use environment variable for API URL, fallback to localhost for development
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000, // 15 seconds timeout
  headers: {
    'Accept-Encoding': 'gzip, deflate',
    'Content-Type': 'application/json',
  }
});

export const sendMessage = async (message) => {
  try {
    const response = await api.post('/chat', {
      message: message
    });
    return response.data;
  } catch (error) {
    console.error('Error sending message:', error);
    
    if (error.code === 'ECONNABORTED') {
      throw new Error('Request timed out. The server is taking too long to respond. Please try again.');
    } else if (error.response?.status === 500) {
      throw new Error('Server error. Please try again in a moment.');
    } else if (error.response?.status === 408) {
      throw new Error('Request timeout. Please try again.');
    } else if (!error.response) {
      throw new Error('Unable to connect to the server. Please check your connection and try again.');
    } else {
      throw new Error(
        error.response?.data?.detail || 
        'Failed to send message. Please try again.'
      );
    }
  }
};

export const healthCheck = async () => {
  try {
    const response = await api.get('/health');
    return response.data;
  } catch (error) {
    console.error('Health check failed:', error);
    throw error;
  }
};
